import React, { ReactNode } from 'react';
import styles from './index.less';

type ContentBlockTitle = {
  className?: string
  title?: ReactNode;
  children?: ReactNode;
};

const ContentBlockTitle = (props: ContentBlockTitle) => {
  return (
    <div className={`${styles.contentBlockTitle} ${props.className}`}>
      <p className={styles.title}>{props.title}</p>
      <div className={styles.body}>{props.children}</div>
    </div>
  );
};

export default ContentBlockTitle;
